import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { WebRequestService } from 'src/app/services/web-request.service';
import * as moment from 'moment';
@Component({
  selector: 'app-remainder',
  templateUrl: './remainder.component.html',
  styleUrls: ['./remainder.component.scss']
})
export class RemainderComponent implements OnInit {

  @ViewChild('successModal')
  private successModal: any;
  @Input()
  isRemainderActive: any;
  @Input()
  profileId: any;
  @Input()
  empId: any;
  @Input()
  ticketId: any;
  @ViewChild('remainderModal')
  remainderModal: any;
  @Output()
  resetRemainderValues = new EventEmitter();
  @Input()
  remainderDateTime: any;
  @Input()
  remainderId: any;
  @Input()
  typeOfDisplay: any;
  @Input()
  fromCustId: any;
  @Input()
  toCustId: any;
  remainderForm: FormGroup;
  remainderFormSubmmited: any = false;
  hoursArray: any = [];
  minutesArray: any = [];
  responseMessage: any = "";
  minDate = new Date();

  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  constructor(public service: WebRequestService) { }

  ngOnInit(): void {

    this.loadBasicData()
  }
  private myValidator = (ctrl: FormControl): ValidationErrors | null => {
    const myDate = new Date(ctrl.value);
    return !ctrl.value || isNaN(myDate.getTime()) || myDate.getFullYear() > 9999 ? { dateInvalid: true } : null;
  }

  ngOnChanges() {

    if (this.isRemainderActive) {
      this.loadBasicData()
      this.remainderModal.show();

    }
  }

  // remainderChange(event) {
  //   const dt = event.target.value;
  //   const dd = dt.getDate();
  //   const mm = dt.getMonth() + 1;
  //   event.targetElement.value = `${dd > 10 ? dd : '0' + dd} / ${mm > 10 ? mm : '0' + mm
  //     } / ${dt.getFullYear()}`;
  // }
  onKeypressEvent(evt) {
    var iKeyCode = (evt.which) ? evt.which : evt.keyCode
    if (iKeyCode != 47 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        return false;
    return true;
} 

  closeModal() {
    this.remainderForm.reset();
    this.resetRemainderValues.emit(false);
    this.remainderModal.hide();
    this.remainderFormSubmmited = false;
  }

  loadBasicData() {
    this.remainderForm = new FormGroup({
      remainderDate: new FormControl("", [Validators.required,this.myValidator]),
      hours: new FormControl("", [Validators.required]),
      minutes: new FormControl("", [Validators.required])
    })
    this.hoursArray = this.bindHoursMinutes(0, 23, 'Hrs', 1)
    this.minutesArray = this.bindHoursMinutes(0, 59, 'Mins', 1)
    if (this.remainderDateTime != null && this.remainderDateTime != undefined) {
      this.populateDateAndTime(this.remainderDateTime)
    }
    if (this.typeOfDisplay === 'matchFollowUp') {
      this.remainderForm.controls['remainderDate'].setValue(new Date(moment(this.remainderDateTime, "DD/MM/YYYY").toDate()))
    }


  }

  populateDateAndTime(date) {
    let splitedValue = date.split(" ")
    this.setDateToDateField(splitedValue[0], splitedValue[1], splitedValue[2]);
    this.setTimeAndMinutes(splitedValue[3])
  }

  bindHoursMinutes(fromval, Toval, str, incrementval) {
    let options = [];
    options.push({ label: str, title: str, value: "" });
    for (let i = fromval; i <= Toval; i += incrementval) {
      if (i < 10) {
        options.push({ label: "0" + i + " " + str, title: "0" + i + " " + str, value: +(parseInt(i) + 1) });
      } else {

        options.push({ label: i + " " + str, title: i + " " + str, value: +(parseInt(i) + 1) });
      }
    }
    return options;
  };

  setDateToDateField(day, monthValue, year) {
    this.remainderForm.controls['remainderDate'].setValue(this.formatDate(`${day} ${monthValue} ${year}`))
  }
  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
  setTimeAndMinutes(time: any) {
    if (time != undefined) {
      let timeValue = time.split(":")
      this.remainderForm.controls['hours'].setValue(parseInt(timeValue[0]) + 1)
      this.remainderForm.controls['minutes'].setValue(parseInt(timeValue[1]) + 1);
    }

  }
  submitRemainderForm() {
    console.log(this.remainderForm.value)
    if (!this.remainderForm.valid) {
      this.remainderFormSubmmited = true;
      return
    } else {
      let convertedDate = this.convertDate(this.remainderForm['value']['remainderDate']);
      let convertedHours = this.convertHoursMinutes(this.remainderForm['value']['hours'])
      let convertMinutes = this.convertHoursMinutes(this.remainderForm['value']['minutes'])
      let modifiedDate = this.convertDateHoursMinutes(convertedDate, convertedHours, convertMinutes);
      this.service.submitRemainder(this.getRemainderObject(modifiedDate)).then((response) => {
        if (response['statusCode'] === 200) {
          this.closeModal();
          this.responseMessage = response['message']
          this.successModal.show();
          setTimeout(() => {
            this.successModal.hide();
          }, 5000);
        } else {
          this.closeModal();
          if (response['message']) {
            this.responseMessage = response['message']
            this.successModal.show();
            setTimeout(() => {
              this.successModal.hide();
            }, 5000);
          }

        }
      })
    }

  }


  getRemainderObject(date) {
    if (this.remainderId != undefined) {
      let remainderObject = {
        Body: "",
        Category: 0,
        DateOfReminder: date,
        EmpID: this.empId,
        IsFollowup: 0,
        Name: "",
        ProfileID: this.profileId,
        RelationID: 0,
        ReminderID: this.remainderId,
        ReminderType1: 0,
        TicketID: this.ticketId
      }
      return remainderObject;
    } else {
      let remainderObject = {
        Body: "",
        Category: 0,
        DateOfReminder: date,
        EmpID: this.empId,
        IsFollowup: 0,
        Name: "",
        ProfileID: this.profileId,
        RelationID: 0,
        ReminderID: 0,
        ReminderType1: 0,
        TicketID: this.ticketId
      }
      return remainderObject;
    }

  }

  convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [month, day, year].join('-');
  }

  convertHoursMinutes(value) {
    return "0" + (value - 1)
  }

  convertDateHoursMinutes(date, hours, minutes) {
    return (date + " " + hours + ":" + minutes + ":00")
  }

  getMothInMMFormat(month) {
    switch (month) {
      case "Jan": return '01';

      case "Feb": return '02';

      case "Mar": return '03';

      case "Apr": return '04';

      case "May": return '05';

      case "Jun": return '06';

      case "Jul": return '07';

      case "Aug": return '08';

      case "Sep": return '09';

      case "Oct": return '10';

      case "Nov": return '11';

      case "Dec": return '12';


    }
  }

  submitRemainderFormForMatchFollowUp() {
    let mfpRemainder =
    {
      "fromcust_id": this.fromCustId != undefined ? this.fromCustId : null,
      "tocust_id": this.toCustId != undefined ? this.toCustId : null,
      "empid": this.empId,
      "intTicketID": this.ticketId,
      "dtRemainderDate": this.remainderForm.value['remainderDate']
    }
    this.service.saveMatchFollowUpRemainder(mfpRemainder).then((response) => {
      if (response['statusCode'] === 200) {
        this.closeModal();
        this.responseMessage = response['message']
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else {
        this.closeModal();
        if (response['message']) {
          this.responseMessage = response['message']
          this.successModal.show();
          setTimeout(() => {
            this.successModal.hide();
          }, 5000);
        }
      }
    })

  }
}
